import { Link } from 'react-router-dom'
import Modal from '../../../core/components/UI/Modal'
import { MdDelete, MdEdit } from 'react-icons/md'
import { IoMdEye, IoMdEyeOff } from 'react-icons/io'
import { FaSpinner } from 'react-icons/fa'
import { toastSuccess } from '../../../helper'
import useSponsorsActions from '../../hooks/useSponsorsActions'
import ButtonDeleteSposnor from './ButtonDeleteSposnor'

export default function ModalSponsorsOptions({ isOpen, onClose, sponsor }) {
  const { changeSponsorStatus, inProgress } = useSponsorsActions()
  console.log(sponsor.id);
  
  async function handleOnChangeSponsorStatus() {
    const message = await changeSponsorStatus(sponsor.id)
    if (message) {
      toastSuccess(message)
      onClose()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`min-w-[512px] border-2 border-muted-500 bg-white`}
    >
      <ul className="flex flex-col gap-1 p-2">
        <li>
          <Link
            to={`/sponsors/${sponsor.id}/edit`}
            className="flex items-center gap-4 border-2 border-muted-300 px-4 py-2 hover:bg-muted-300"
          >
            <MdEdit size={18} />
            <div>تعديل الراعي</div>
          </Link>
        </li>
        <li>
          <button
            onClick={handleOnChangeSponsorStatus}
            disabled={inProgress}
            className="flex w-full items-center gap-4 border-2 border-muted-300 px-4 py-2 hover:bg-muted-300 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
          >
            {inProgress ? (
              <div className="flex items-center">
                <FaSpinner
                  size={16}
                  className="ml-2 animate-spin"
                />
                <div>جاري تغيير حالة الراعي...</div>
              </div>
            ) : (
              <>
                {sponsor.is_published === 1 ? (
                  <>
                    <IoMdEyeOff />
                    <div>إلغاء النشر</div>
                  </>
                ) : (
                  <>
                    <IoMdEye />
                    <div>نشر</div>
                  </>
                )}
              </>
            )}
          </button>
        </li>
        <li>
          <ButtonDeleteSposnor
            sponsorId={sponsor.id}
            onClose={onClose}
          />
        </li>
      </ul>
    </Modal>
  )
}
